import store from '@app/app.store';
import * as models from '@app/models';
import { Grid, StyleRules, withStyles } from '@material-ui/core';
import { History } from 'history';
import * as React from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';

import { UserRole } from '@app/app.enum';
import CarriersListComponent from '@app/components/carriers/carriers-list.component';

const styles: StyleRules = {};

class CarriersComponent extends React.Component<{ history: History; classes: any; intl: InjectedIntl }, {}> {
	private userType: UserRole;

	constructor(props: { history: History; classes: any; intl: InjectedIntl }) {
		super(props);
		this.state = {};
		this.handleClick = this.handleClick.bind(this);
		this.userType = store.getState().authentication.user.role;
	}

	public handleClick(carrier: models.ICarrier) {
		this.props.history.push(`/carrier`, {
			carrierId: carrier.id,
			breadcrumb: {
				title: carrier.code,
				location: this.props.history.location,
			},
		});
	}

	public render() {
		return (
			<Grid container={true} justifyContent='center'>
				<Grid item={true} xs={11}>
					<CarriersListComponent
						new={false}
						mounted={true}
						userType={this.userType}
						showCarrierCode={true}
						showCarrierAppWise={true}
						onClick={this.handleClick}
					/>
				</Grid>
			</Grid>
		);
	}
}

export default withStyles(styles)(injectIntl(CarriersComponent));



// WEBPACK FOOTER //
// ./src/components/admin/carriers/carriers.component.tsx